module.exports = __webpack_public_path__ + "img/24.c4ad4e4.svg";